<template>
  <bl-button-av size="large" @click="gotoLoginPage">
    Daftar jadi investor
  </bl-button-av>
</template>

<script>
/* istanbul ignore file */
import BlButtonAv from '@bukalapak/bazaar-dweb-v2/dist/components/BlButtonAv';
import queryString from 'query-string';

export default {
  name: 'RegisterButton',
  components: {
    BlButtonAv,
  },

  methods: {
    gotoLoginPage() {
      window.location.href = `/login?${queryString.stringify({
        comeback: this.$route.fullPath,
        direct: 1,
      })}`;
    },
  },
};
</script>
